import { useQuery } from "@tanstack/react-query";
import { getEcommAverageOrderValue } from "../services/ecommAOVService";

export type AOVChartEntry = {
  month: string;
  [year: string]: number | string;
};

export const useEcommAverageOrderValue = () => {
  return useQuery<Awaited<ReturnType<typeof getEcommAverageOrderValue>>, Error, {
    chartData: AOVChartEntry[];
    yoyChange: number;
    currentAOV: number;
    highestMonth: {
      year: number;
      month: string;
      value: number;
    };
    lastYearAvg: number;
  }>({
    queryKey: ["ecomm-averageOrderValue"],
    queryFn: () => getEcommAverageOrderValue(),
    staleTime: 1000 * 60 * 5, 
    select: (data) => {
      const chartData: AOVChartEntry[] = [];

      data.aov_per_month.forEach(({ period, value }) => {
        const [year, monthNum] = period.split("-");
        const monthLabel = new Date(+year, +monthNum - 1).toLocaleString("default", {
          month: "short",
        });

        const existing = chartData.find((entry) => entry.month === monthLabel);
        if (existing) {
          existing[year] = value;
        } else {
          chartData.push({
            month: monthLabel,
            [year]: value,
          });
        }
      });

      // Sort by month order
      const monthOrder = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

      chartData.sort((a, b) => monthOrder.indexOf(a.month) - monthOrder.indexOf(b.month));

      return {
        chartData,
        yoyChange: data.aov_yoy.yoy_change_percent,
        currentAOV: data.aov_yoy.current_aov,
        highestMonth: data.highest_aov,
        lastYearAvg: data.avg_of_all_avg_last_year,
      };
    },
  });
};
